import state from "./state";
import dataPt_br from '../../data/pt-br/stone-detail'
import dataEn_us from '../../data/en-us/stone-detail'
import moment from "moment";


export default {
  stoneList(state) {
    return state.stones.length > 0 ? state.stones : [];
  },

  totalStones(state){
    return state.total;
  },

  nextPageDisable(state){
    return state.filters.last_page || state.loading
  },
  stoneSelected(state) {
    return (
        {
          ...state.stone_selected,
            length_img_3d: state.stone_selected.images.filter(i => i.is_favorite).length
          
        }|| {
          id: 0,
          name_material: "",
          type: "",
          bloc_number: 0,
          width: 0,
          height: 0,
          weight: 0,
          diameter: 0,
          user_id: 0,
          company_id: 0,
          created_at: "0000-00-00 00:00",
          updated_at: "",
          images: [],
          videos: [],
        }
      );
  },

  stoneDetail(state) {
    return (
      state.stone_detail ?
      {
        ...state.stone_detail,
          total_images: state.stone_detail.images.length,
          length_img_3d: state.stone_detail.images.filter(i => !i.is_favorite).length,
          images:  state.stone_detail.images.filter(i => i.is_favorite),
          video_label: `${state.stone_detail.videos[0].path} (${(state.stone_detail.videos[0].size / 1000000).toFixed(2)} MB)`,
          label_obj: state.stone_detail.bloc_3d ? `${state.stone_detail.bloc_3d.obj_file} (${(  state.stone_detail.bloc_3d.size / 1000).toFixed(2)}KB)` : '--',
          label_created: moment(state.stone_detail.created_at).fromNow()
        }
      :
      {
        id: 0,
        name_material: "",
        type: "",
        bloc_number: 0,
        width: 0,
        height: 0,
        weight: 0,
        diameter: 0,
        user_id: 0,
        company_id: 0,
        created_at: "0000-00-00 00:00",
        updated_at: "",
        images: [],
        videos: [],
        length_img_3d: 0,
        total_images: 0,
        bloc_3d: null,
        video_label: ''
      }
    );
  },

  teste(){
    return navigator.language;
  },

  dataStoneLocale(){
   return navigator.language === "pt-BR" ? dataPt_br : dataEn_us
  }
};
